import request from './request'

// 获取所有栏目
export function getall(params) {
    return request({
        url: '/api/columns/get?enable=1',
        method: 'get',
        data: params
    })
}
// 首页
export function getsy(id,params) {
    return request({
        url: '/api/content/get?columnId='+id+"&enable=1&sort=tag%2Casc",
        method: 'get',
        params
    })
}
export function getsy1(id,params) {
    return request({
        url: '/api/content/get?columnId='+id+"&enable=1&sort=releaseTime%2Cdesc",
        method: 'get',
        params
    })
}
// 获取首页栏目
export function getsycolumn(id,params) {
    return request({
        url: '/api/columns/get?parentId='+id+"&enable=1",
        method: 'get',
        data: params
    })
}
// 获取首页资源
export function getsyres(id,params) {
    return request({
        url: '/api/contentResource/get?contentId='+id,
        method: 'get',
        data: params
    })
}
// 获取企业简介
export function getqyjj(id,params) {
    return request({
        url: '/api/content/get?columnId='+id+"&enable=1",
        method: 'get',
        data: params
    })
}
// 获取案例详情
export function getcaseDetail(id,params) {
    return request({
        url: 'api/cmsCustomercase?id='+id,
        method: 'get',
        data: params
    })
}
// 通过内容id查询
export function getcontent(id,params) {
    return request({
        url: '/api/content/get?contentId='+id+"&enable=1&sort=tag%2Casc",
        method: 'get',
        data: params
    })
}
// 新增留言
export function addhelp(data) {
    return request({
        url: '/api/cmsHelp',
        method: 'post',
        data: data
    })
}
// 通过栏目id查询内容
export function getPostDetail(data) {
    return request({
        url: '/api/content/getByColumnids',
        method: 'post',
        data: data
    })
}


// 通过内容id获取svg列表
export function getSvgList(params) {
    return request({
        url: '/api/contentSvg',
        method: 'get',
        params
    })
}

// 查看产品日志
export function getProductInfo(params) {
    return request({
        url: '/api/productUpdateLog',
        method: 'get',
        params
    })
}


// 查看图片资源
export function getResouceInfo(params) {
    return request({
        url: '/api/sysResource',
        method: 'get',
        params
    })
}



// 产品归档查询
export function getProductList(params) {
    return request({
        url: '/api/product',
        method: 'get',
        params
    })
}

// 招聘岗位
export function getZhaoPinList(params) {
    return request({
        url: '/api/recruitInfo',
        method: 'get',
        params
    })
}

// 查询字典
export function DictList(params) {
    return request({
        url: '/api/dict',
        method: 'get',
        params
    })
}




// WEBPACK FOOTER //
// ./src/request/index.js